import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-tables',
  templateUrl: './ui-tables.component.html'
})
export class UiTablesComponent implements OnInit {

  badges: string[] = ['primary', 'secondary', 'success'];

  constructor() { }

  ngOnInit() {
  }

}
